import {Controlador, type IControlador} from "../../../../root/controlador";
import type {ICache, Builder} from "../data/builders";
import {NoticiaPlantilla} from "../tmpl";
import {ESelector} from "../data/auxiliares";

export interface IControladorRedaccionUltimas extends IControlador {
    selector: ESelector;
    promocionados: boolean,
}

export abstract class ControladorRedaccionUltimas extends Controlador<IControladorRedaccionUltimas> {
    /* INSTANCE */
    protected abstract builder: Builder;
    protected limite: number;
    protected plantilla?: NoticiaPlantilla;

    protected constructor(ctx: IControladorRedaccionUltimas) {
        super(ctx);

        this.limite = 4;
    }

    protected abstract getPlantilla(): Promise<NoticiaPlantilla>;

    public override async run(): Promise<void> {
        const expires = new Date(this.element.getAttribute("data-expires")??0);
        if (expires.getTime()>=Date.now()) {
            return;
        }

        const noticias = await this.builder.load(this.ctx.dominio);

        const dataID = this.element.getAttribute("data-id");
        if (dataID!=null) {
            const id = parseInt(dataID);
            noticias.data = noticias.data.filter(noticia=>noticia.id!=id);
        }
        if (!this.ctx.promocionados) {
            noticias.data = noticias.data.filter(noticia=>!noticia.promocionado);
        }
        await this.redibujar(noticias);
    }

    private async redibujar({data, expires}: ICache): Promise<void> {
        this.plantilla ??= await this.getPlantilla();

        const noticias = data.slice(0, this.limite);
        if (noticias.length<this.limite) {
            return;
        }

        const contenido = this.plantilla({noticias: noticias, lazy: false});

        requestAnimationFrame(()=>{
            this.element.setAttribute("data-expires", expires);
            this.element.innerHTML = contenido; // todo animar esto cuando el componente es visible
            // if (this.primeraEjecucion) {
            //     require("./plantillas/estilos.css");
// .fade-out {
//         animation: fadeOut 0.5s forwards;
//     }
//
// .fade-in {
//         animation: fadeOut 0.5s forwards;
//     }
//
//         .fade-in {
//         animation: fadeIn 0.5s forwards;
//     }
//
// @keyframes fadeOut {
//         from { opacity: 1; }
//         to { opacity: 0; }
//     }
//
// @keyframes fadeIn {
//         from { opacity: 0; }
//         to { opacity: 1; }
//     }

            // }
            // // Add fade-out class to the element
            // this.element.classList.add("fade-out");
            //
            // // Wait for the fade-out animation to complete
            // this.element.addEventListener("animationend", () => {
            //     // Remove the fade-out class
            //     this.element.classList.remove("fade-out");
            //
            //     // Update the content
            //     this.element.innerHTML = contenido;
            //
            //     // Add fade-in class to the element
            //     this.element.classList.add("fade-in");
            //
            //     // Remove the fade-in class after the animation completes
            //     this.element.addEventListener("animationend", () => {
            //         this.element.classList.remove("fade-in");
            //     }, { once: true });
            // }, { once: true });
        });
    }
}
